import {
  FormClient,
  FormClientType,
} from '../strategies/form/strategy.form.client'
import { NangoClient } from '../strategies/nango/strategy.nango.client'
import {
  Oauth2Client,
  Oauth2ClientType,
} from '../strategies/oauth2/oauth2client'

export type NangoClientType = ReturnType<typeof NangoClient>

export type ProviderAuthenticationClientType =
  | Oauth2ClientType
  | NangoClientType
  | FormClientType

export const ProviderAuthenticationClient = {
  Form: FormClient,
  Oauth2: Oauth2Client,
  Nango: NangoClient,
}
